import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import {
  ASSIGN_QUESTIONS_TO_FORM_SECTION,
  CREATE_QUESTIONS_URLS,
  CREATE_SECTION_IN_FORM,
  DELETE_SECTION_URL,
  EDIT_QUESTIONS_URL,
  EDIT_SECTION_URL,
  GET_FORM,
  get_headers,
  get_project_id,
  GET_SECTIONS_IN_FORM,
  get_token,
  QUESTION_TYPE_URLS,
  SECTIONS_LIST_URLS,
  UNASSIGN_QUESTIONS_TO_FORM_SECTION
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import CreateMainSections from "@/views/probaworkflows_base/management/survey_managment/create_main_sections/CreateMainSections.vue";
import CreateQuestions from "@/views/probaworkflows_base/management/survey_managment/create_questions/CreateQuestions.vue";
import ConfigureVerificationQuestions from '@/views/probaworkflows_base/verification/configure_verification_questions/ConfigureVerificationQuestions.vue';
import CreateSections from "@/views/probaworkflows_base/management/survey_managment/create_sections/CreateSections.vue";
import PreviewForm from "@/views/probaworkflows_base/management/survey_managment/preview_form/PreviewForm.vue";
import ComplianceChecklist from "@/views/probaworkflows_base/compliance/configurations/compliance_checklist/ComplianceChecklist.vue";
import OnGoingComplianceChecklist from "@/views/probaworkflows_base/compliance/configurations/ongoing_compliance/OnGoingComplianceChecklist.vue";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from "jquery";
import Swal from "sweetalert2";
import { nextTick } from "vue";

const SELECT_TYPES = ['multi_select', 'single_select'];

export default {
  name: "CreateEntity",
  mixins: [alert_mixin, formatting_mixins],
  components: { GlobalTable, CreateSections, CreateQuestions, PreviewForm, NavigationBackButton, 
                CreateMainSections , ConfigureVerificationQuestions, ComplianceChecklist, OnGoingComplianceChecklist},

  data() {
    return {
    removed_question_ids: [],
    question_types: [],
    section_types: [],
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    form_id: this.$route.query.form_id,
    entity_type_name: sessionStorage.getItem('entity_type_name'),
    form_type: sessionStorage.getItem('form_type') || '',
    form_name : sessionStorage.getItem("form_name"),
    active_tab: "Manage Forms",
    sub_active_tab: "Main Sections",
    tabs: [
      "Manage Forms", "Manage Template", "Manage Approval Rules",
      "Manage Invoice Steps", "Manage Compliance"
    ],
    sub_tabs: ["Main Sections", "Sections", "Create Questions","Verify Questions" ,"Preview Job Information", "Onboarding Checklist"],
    section_list: [],
    section_table_headers: [],
    table_safe_section_list: [],
    preview_sections: [],
    question_forms: [this.create_empty_question_form()],
    show_edit_section_modal: false,
    show_edit_modal: false,
    current_edit_section: { id: null, name: '', order: null },
    current_edit_question: this.create_empty_edit_question(),
    section_name_error: false,
    section_name: "",
    option_inputs: ['', '']
  }
  },

  computed: {
    filtered_data() {
      const dataMap = {
        "Create Questions": this.question_forms,
        "Preview Job Information": this.preview_sections
      };
      return dataMap[this.sub_active_tab] || [];
    },
    check_question_type() {
      const type = this.question_types.find(t => t.id === this.question_type_id);
      return SELECT_TYPES.includes(type?.question_type);
    },
    is_onboarding_checklist_form() {
      const form_type = (this.form_type || "").trim().toLowerCase();
      return form_type === "onboarding checklist";
    },
    is_compliance_checklist_form() {
      const form_type = (this.form_type || "").trim().toLowerCase();
      return form_type === "compliance form";
    }
  },

  methods: {
    create_empty_question_form() {
      return ({ question_text: "", question_number: "", question_type_id: "", mandatory: "", option_inputs: ['', ''], show_option_inputs: false });
    },

    create_empty_edit_question: () => ({
      id: null,
      question_index: null,
      question_text: '',
      question_type: '',
      question_type_id: '',
      options: [],
      show_option_inputs: false
    }),


    assign_question(section_id) {
      if (!this.form_id) {
        this.show_error('Please save the form first');
        return;
      }
      sessionStorage.setItem('current_form_id', this.form_id);
      sessionStorage.setItem('current_section_id', section_id);
      this.$router.push({
        path: '/manage_questions',
        query: { form_id: this.form_id, section_id, project_id: this.project_id }
      });
    },

    handle_question_type_change(form) {
      const type = this.question_types.find(t => t.id === form.question_type_id);
      form.show_option_inputs = SELECT_TYPES.includes(type?.question_type);
      if (form.show_option_inputs) {
        form.option_inputs = form.option_inputs?.length >= 2 ? form.option_inputs : ['', ''];
      } else {
        form.option_inputs = [];
      }
    },

    add_option_input(form) {
      form.option_inputs.push('');
    },

    remove_option_input(index, form) {
      if (form.option_inputs.length > 2) {
        form.option_inputs.splice(index, 1);
      }
    },

    async create_form_question(form) {
      try {
      if (!form.question_text.trim()) return this.show_error("Question text is required");
      if (!form.question_type_id) return this.show_error("Question type is required");

      const type = this.question_types.find(t => t.id === form.question_type_id);
      const is_select_type = SELECT_TYPES.includes(type?.question_type);

      const payload = {
        question_text: form.question_text.trim(),
        question_type_id: form.question_type_id,
        project_id: this.project_id,
        is_mandatory: form.mandatory === "Yes",
        question_number: form.question_number || null,
        options: is_select_type ?
          form.option_inputs.filter(opt => Boolean(opt.trim())) : [],
        section_id: this.section_id || null
      };

      if (is_select_type && payload.options.length < 2) {
        return this.show_error("At least two valid options are required");
      }

      const { data } = await axios.post(CREATE_QUESTIONS_URLS, payload, { headers: this.headers });
      const response = typeof data === "string" ? JSON.parse(data) : data;

      if (response.status === "success") {
        this.show_success("Question created successfully");
        if (payload.section_id) {
          await this.assign_questions_to_section([response.data.question_id], payload.section_id);
        }
        this.reset_question_form();
        this.get_form_to_preview();
      } else {
        this.show_error(response.message || "Error creating question");
      }
    }catch (error) {
      this.show_error(`Error creating question: ${error.message}`);
    }
    },

    update_option(index, value, form) {
      if (Number.isInteger(index) && index >= 0 && index < form.option_inputs.length) {
        form.option_inputs[index] = (typeof value === 'string' && value.trim() !== '' && /^[a-zA-Z0-9 ]+$/.test(value)) ? String(value.trim()) : form.option_inputs[index];
      }
    },

    set_edit_question_data(question, question_index) {
      if (!question?.id) throw new Error('Question data incomplete');

      const question_type = this.question_types.find(
        t => t.question_type === question.question_type?.question_type
      );

      // Ensure options are properly formatted
      const options = (question.multi_select_choices || question.options || []).map(opt => {
        if (typeof opt === 'object') {
          // Only keep the properties we expect
          return {
            choice: opt.choice || '',
            id: opt.id // Preserve ID if it exists
          };
        }
        return { choice: opt || '' };
      });

      this.current_edit_question = {
        id: question.id.toString(),
        question_index,
        question_text: question.question_text || '',
        question_type: question.question_type?.question_type || '',
        question_type_id: question_type?.id?.toString() || '',
        options: options.length ? options : [{ choice: '' }],
        show_option_inputs: SELECT_TYPES.includes(question.question_type?.question_type || '')
      };

      // Sync with option_inputs for the UI
      this.option_inputs = options.map(opt => opt.choice);
    },

    edit_preview_question(question, question_index) {
      try {
        this.set_edit_question_data(question, question_index);
        this.show_edit_modal = true;
      } catch (error) {
        this.show_error(error.message);
      }
    },

    async save_edited_question() {
      try {
        if (!this.current_edit_question?.id) {
          return this.show_error('Question ID missing');
        }
        if (!this.current_edit_question.question_text?.trim()) {
          return this.show_error('Question text required');
        }
        if (!this.current_edit_question.question_type_id) {
          return this.show_error('Question type required');
        }

        const payload = {
          question_id: this.current_edit_question.id,
          question_text: this.current_edit_question.question_text.trim(),
          question_type_id: this.current_edit_question.question_type_id,
          options: this.current_edit_question.show_option_inputs ?
            this.current_edit_question.options
              .map(opt => typeof opt === 'object' ? opt.choice : opt)
              .filter(choice => choice?.trim()) : []
        };

        if (this.current_edit_question.show_option_inputs && payload.options.length < 2) {
          return this.show_error('At least two valid options required');
        }

        const { data } = await axios.put(EDIT_QUESTIONS_URL, payload, { headers: this.headers });
        const response = typeof data === "string" ? JSON.parse(data) : data;

        if (response.status === "success") {
          this.show_success('Question updated');
          this.show_edit_modal = false;
          this.get_form_to_preview();
          this.sub_active_tab = "Preview Form";
        } else {
          this.show_error(response.message || 'Update failed');
        }
      } catch (error) {
        this.show_error(`Update failed: ${error.response?.data?.message || error.message}`);
      }
    },

    async unassign_question(question_id, form_section_id) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'This will remove the question from this section only!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove it!'
      });

      if (!result.isConfirmed) return;

      try {
        const payload = {
          question_ids: [question_id],
          form_section_id,
          project_id: this.project_id,
          form_id: this.form_id
        };

        await axios.post(UNASSIGN_QUESTIONS_TO_FORM_SECTION, payload, { headers: this.headers });

        this.preview_sections = this.preview_sections.map(section =>
          section.id === form_section_id ? {
            ...section,
            questions: section.questions?.filter(q => q.id !== question_id) || []
          } : section
        );

        this.show_success('Question removed');
        this.get_form_to_preview();
      } catch (error) {
        const errorMsg = error.response?.data?.message || error.response?.data?.detail || 'Removal failed';
        this.show_error(errorMsg);
      }
    },

    async fetch_sections() {
      try {
        const { data } = await axios.get(SECTIONS_LIST_URLS, { headers: this.headers });
        this.section_types = data.data || [];
      } catch (error) {
        this.show_error(`Error fetching sections: ${error.response?.data?.message || error.message}`);
      }
    },

    async create_section() {
    try {
      if (!this.section_name.trim()) {
        this.section_name_error = true;
        return this.show_error("Section name required");
      }

      const payload = {
        project_id: this.project_id,
        form_id: this.form_id,
        section_name: this.section_name.trim(),
      };

      await axios.post(CREATE_SECTION_IN_FORM, payload, { headers: this.headers });
      this.show_success(`Section ${this.section_name} created`);
      this.section_name = "";
      this.section_name_error = false;
      this.get_sections();
    }catch (error) {
      this.show_error(`Error creating section: ${error.response?.data?.message || error.message}`);
    }
    },

    open_edit_section_modal(section) {
      this.current_edit_section = {
        id: section.id,
        name: section.section_name,
        order: section.order
      };
      this.show_edit_section_modal = true;
      this.section_name_error = false;
    },

    async save_edited_section() {
      if (!this.current_edit_section?.id) return this.show_error("Section ID missing");
      if (!this.current_edit_section.name?.trim()) {
        this.section_name_error = true;
        return this.show_error("Section name required");
      }

      try {
        const payload = {
          name: this.current_edit_section.name.trim(),
          section_id: this.current_edit_section.id
        };

        const { data } = await axios.put(EDIT_SECTION_URL, payload, { headers: this.headers });
        const response = typeof data === 'string' ? JSON.parse(data) : data;

        if (response.status === 'success') {
          Swal.fire('Success', response.message || 'Section updated', 'success');
          this.get_sections();
        } else {
          Swal.fire('Error', response.message || 'Update failed', 'error');
        }
      } catch (error) {
        const errorData = error.response?.data;
        const errorMsg = typeof errorData === 'string' ?
          (JSON.parse(errorData)?.message || errorData) :
          (errorData?.message || errorData?.detail || 'Update failed');

        Swal.fire('Error', errorMsg, 'error');
      }
    },

    async delete_section(section_id) {
      const result = await Swal.fire({
        title: 'Delete Section?',
        text: 'This will also delete all questions in this section',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Delete'
      });

      if (!result.isConfirmed) return;

      try {
        const { data } = await axios.delete(DELETE_SECTION_URL, {
          data: { section_id },
          headers: this.headers
        });

        if (data?.status === 'success') {
          Swal.fire('Deleted!', data.message || 'Section deleted', 'success');
          this.get_sections();
        } else {
          Swal.fire('Error', data?.message || 'Deletion failed', 'error');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data?.message || 'Deletion failed', 'error');
      }
    },

    async get_data_point_types() {
      try {
        const { data } = await axios.get(QUESTION_TYPE_URLS, { headers: this.headers });
        const types = typeof data === 'string' ? JSON.parse(data) : data;
        this.question_types = types.data.map(item => ({
          ...item,
          formatted_type: this.format_question_type(item.question_type),
        }));
      } catch (error) {
        this.show_error(`Error retrieving question types: ${error.message}`);
      }
    },

    async get_sections() {
      this.section_list = [];
      try {
        const { data } = await axios.post(GET_SECTIONS_IN_FORM,
          { form_id: this.form_id },
          { headers: this.headers }
        );

        if (data?.data?.length) {
          this.section_list = data.data;
          this.prep_tables();
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          this.show_error(`Error getting sections: ${error.response?.data?.message || error.message}`);
        }
      }
    },

    prep_tables() {
      if (this.section_list.length) {
        this.table_safe_section_list = this.section_list.map(section => ({
          id: section.section_id,
          section_name: section.section_name,
        }));
        this.section_table_headers = Object.keys(this.table_safe_section_list[0]);
      }
      this.initialize_data_table();
    },

    async get_form_to_preview() {
      try {
        const { data } = await axios.get(GET_FORM, {
          headers: this.headers,
          params: { form_id: this.form_id },
        });

        this.preview_sections = (data.data?.sections || []).map(section => ({
          id: section.id,
          name: section.name,
          order: section.order_number,
          questions: (section.questions || [])
            .filter(q => !this.removed_question_ids.includes(q.id))
            .map(question => ({
              id: question.id,
              question_text: question.question_text,
              question_type: {
                question_type: question.question_type.question_type,
                id: question.question_type.id
              },
              is_mandatory: question.is_mandatory,
              question_number: question.question_number,
              options: question.options || [],
              multi_select_choices: question.multi_select_choices || []
            }))
        }));
      } catch (error) {
        this.show_error(`Error getting form: ${error.response?.data?.message || error.message}`);
      }
    },

    async set_active_tab(tab) {
      this.active_tab = tab;
      await nextTick();
      this.initialize_data_table();
    },

    async set_sub_active_tab(tab) {
      this.sub_active_tab = tab;
      localStorage.setItem('sub_active_tab', this.sub_active_tab);
      await nextTick();
      this.initialize_data_table();
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const tableMap = {
          Sections: "#create-sections-table",
        };

        const tableId = tableMap[this.sub_active_tab];
        if (!tableId || !document.querySelector(tableId)) return;

        if ($.fn.DataTable.isDataTable(tableId)) {
          $(tableId).DataTable().destroy();
        }

        $(tableId).DataTable({ responsive: true, destroy: true });
      });
    },

    add_question_form() {
      this.question_forms.push(this.create_empty_question_form());
    },

    remove_question_form(index) {
      this.question_forms.splice(index, 1);
    },

    async assign_questions_to_section(question_ids, section_id) {
      if (!question_ids?.length || !section_id) return null;

      try {
        const payload = {
          project_id: this.project_id,
          form_id: this.form_id,
          section_id,
          question_ids
        };

        const { data } = await axios.post(
          ASSIGN_QUESTIONS_TO_FORM_SECTION,
          payload,
          { headers: this.headers }
        );

        const response = typeof data === "string" ? JSON.parse(data) : data;
        if (response.success) {
          this.show_success("Question assigned to section");
          this.get_form_to_preview();
        }
        return response;
      } catch (error) {
        this.show_error(`Error assigning question: ${error.response?.data?.message || error.message}`);
        return null;
      }
    },

    reset_question_form() {
      this.question_forms = [this.create_empty_question_form()];
      this.option_inputs = ['', ''];
    },

    go_back_to_view_entity_type() {
      this.$router.push("/view_entity_type");
    }
  },

  mounted() {
    const saved_tab = localStorage.getItem("sub_active_tab");

    this.headers = get_headers();
    this.get_sections();
    this.get_data_point_types();
    this.get_form_to_preview();
    this.initialize_data_table();
    if (saved_tab) {
      this.set_sub_active_tab(saved_tab);
    } else if (this.sub_tabs.length > 0) {
      this.set_sub_active_tab(this.sub_tabs[0]);  
    }
    if (saved_tab === "Onboarding Checklist" && !this.is_onboarding_checklist_form) {
      this.set_sub_active_tab("Main Sections");
    }
  },

  watch: {
    question_type_id() {
      this.handle_question_type_change(this);
    },
    create_sections: 'initialize_data_table',
    create_questions: 'initialize_data_table',
    preview_form: 'initialize_data_table'
  }
};